import React from 'react';
import { Alert } from '@/components/markdown/Alert';
import { Search, Database, Bot, ArrowRight, FileText } from 'lucide-react';

const VertexDataStoreDemo = () => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 text-sm">
        <Database className="h-4 w-4 text-blue-500"/>
        <div className="flex-1 truncate bg-muted px-2 py-1 rounded">
          Vertex AI DataStore
        </div>
      </div>
      
      <div className="bg-muted/20 rounded-lg p-3">
        <div className="text-sm font-medium mb-2">Assistant Knowledge Enhancement</div>
        <div className="flex items-start gap-3 text-xs mb-3">
          <div className="flex-shrink-0 w-7 h-7 bg-blue-100 rounded-full flex items-center justify-center">
            <Search className="h-4 w-4 text-blue-500" />
          </div>
          <div>
            <span className="font-medium">Query:</span>
            <div className="mt-1 p-1.5 bg-white border rounded">
              "How do I implement authentication?"
            </div>
          </div>
        </div>
        
        <div className="flex items-center my-2 text-xs text-muted-foreground">
          <div className="h-px bg-muted-foreground/30 flex-grow mr-2"></div>
          <ArrowRight className="h-3 w-3" />
          <div className="h-px bg-muted-foreground/30 flex-grow ml-2"></div>
        </div>
        
        <div className="flex items-start gap-3 text-xs">
          <div className="flex-shrink-0 w-7 h-7 bg-purple-100 rounded-full flex items-center justify-center">
            <Database className="h-4 w-4 text-purple-500" />
          </div>
          <div>
            <span className="font-medium">DataStore Response:</span>
            <div className="mt-1 space-y-2">
              <div className="p-1.5 bg-white border rounded flex items-start gap-2">
                <FileText className="h-3 w-3 mt-0.5 text-gray-500" />
                <div>
                  <div className="font-medium">Authentication API Overview</div>
                  <div className="text-muted-foreground text-xs mt-0.5 line-clamp-2">
                    The authentication system supports OAuth2, API keys, and JWT tokens...
                  </div>
                </div>
              </div>
              
              <div className="p-1.5 bg-white border rounded flex items-start gap-2">
                <FileText className="h-3 w-3 mt-0.5 text-gray-500" />
                <div>
                  <div className="font-medium">Security Best Practices</div>
                  <div className="text-muted-foreground text-xs mt-0.5 line-clamp-2">
                    Always use HTTPS and implement proper token validation...
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="flex items-center my-2 text-xs text-muted-foreground">
          <div className="h-px bg-muted-foreground/30 flex-grow mr-2"></div>
          <ArrowRight className="h-3 w-3" />
          <div className="h-px bg-muted-foreground/30 flex-grow ml-2"></div>
        </div>
        
        <div className="flex items-start gap-3 text-xs">
          <div className="flex-shrink-0 w-7 h-7 bg-green-100 rounded-full flex items-center justify-center">
            <Bot className="h-4 w-4 text-green-500" />
          </div>
          <div>
            <span className="font-medium">Enhanced Response:</span>
            <div className="mt-1 p-1.5 bg-white border rounded">
              <p className="text-xs leading-relaxed">
                Based on our documentation, you can implement authentication using:
                <br/><br/>
                1. OAuth2 for user authentication
                <br/>
                2. API keys for service-to-service communication
                <br/>
                3. JWT tokens for stateless authentication
                <br/><br/>
                All methods require HTTPS and proper token validation...
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="rounded-lg border p-2 flex items-center justify-between text-xs">
        <div className="flex items-center gap-1.5">
          <Database className="h-3.5 w-3.5 text-blue-500" />
          <span className="font-medium">Connected to:</span>
          <span className="font-mono bg-muted px-1.5 py-0.5 rounded text-[10px]">
            aitana-documentation
          </span>
        </div>
        <div className="text-emerald-600 flex items-center gap-1">
          <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></div>
          Active
        </div>
      </div>
      
      <Alert type="success">
        <div className="flex items-center gap-2 text-xs">
          <span>Assistant can automatically retrieve relevant information from your DataStore</span>
        </div>
      </Alert>
    </div>
  );
};

export default VertexDataStoreDemo;